<template>
    <div class="gpt-chatbox-content" :class="{ focusTyping }">
        <div class="gpt-chatbox" >
        <template v-if="!simpleChatBox">
            <div class="gpt-chatbox__select--h5" v-show="selectModeMinShow" @click.stop>
                <span class="h5-select__label">当前：</span>
                <span class="h5-select__value">{{ activeName }}</span>
                <span v-if="selectModeDialogShow" class="h5-select__fold" @click.stop="handelModelSelect(false)">收起</span>
                <span v-else class="h5-select__fold" @click.stop="handelModelSelect(true)">模型选择</span>
            </div>
            <div class="select-wrapper" :class="selectModeDialogShow ? 'select-wrapper--dialog' : ''" v-show="!selectModeMinShow || selectModeDialogShow">
                <div v-for="cat in categoryList" :key="cat" class="select-row">
                    <div class="title">
                        {{cat}}
                    </div>
                    <div class="select-content">
                        <div class="item" v-for="item in modelList.filter((item)=>{return item.category === cat})" :key="item.value"
                            :class="{active: item.value === active}" @click="selectModeDialogShow = false;setActive(item)">
                            {{ item.title }}
                        </div>
                    </div>
                </div>
                <el-tooltip content="查看模型详情" placement="top" :popper-class="isDark?'show-detail-tooltip show-detail-tooltip-dark':'show-detail-tooltip'">
                    <div class="showModelDetail" @click="showModel"></div>
                </el-tooltip>
            </div>
        </template>
        <div v-if="!forceRefresh" class="input-content">
            <!-- 应用输入-->
            <gpt-chatbox-common v-if="active === 'assistantMode'" @focus-typing="handelFocusTyping"
                                :input="prompt" :typing="typing" placeholder="请输入问题" :sessionId="sessionId"
                                :simpleChatBox="true"
                                :showMic="showMic"
                                @commonAsk="$emit('assistantAsk', $event)" />
            <!-- 普通输入-->
            <gpt-chatbox-common v-else-if="active === 'commonMode'" @focus-typing="handelFocusTyping"
                                :showMic="showMic"
            :input="prompt" :typing="typing" :placeholder="simpleChatBox ? simpleChatBoxPlaceholder : commonPlaceholder" :simpleChatBox="simpleChatBox" :sessionId="sessionId"
            @setModel="setModel" @commonAsk="$emit('commonAsk', $event)" />

            <template v-else-if="active !== 'commonMode'">
                <!-- 模型输入-->
                <template v-for="item in modelList">
                    <component v-if="item.value === active" :is="item.chatbox" :key="item.value"
                               :showMic="showMic"
                               :input="item.prompt" :typing="typing" :placeholder="item.placeholder" :promptTemplate="item.promptTemplate" :sessionId="sessionId"
                               :modelSettings="item.modelSettings"
                               @focus-typing="handelFocusTyping"
                               @setModel="setModel" @commonAsk="$emit('commonAsk', $event)" @knowledgeAsk="$emit('knowledgeAsk', $event)" @thinkAsk="$emit('thinkAsk', $event)" @inputAsk="$emit('inputAsk', $event)" @trafficAsk="$emit('trafficAsk', $event)" @askAnswer="$emit('askAnswer', $event)" @askAnswerLoading="$emit('askAnswerLoading', $event)" @askAnswerFinish="$emit('askAnswerFinish', $event)" />
                </template>
            </template>
        </div>
    </div>
    </div>
</template>

<script>
export default {
    name: 'gpt-chatbox',
    data () {
        return {
            focusTyping: false,
            prompt: '',
            active: '',
            activeName: '',
            selectModeMinShow: true,
            selectModeDialogShow: false,
            selectModeDialogCategory: null,
            commonPlaceholder: '在此输入您想了解的内容，输入“/”可获取模板，按alt+回车换行，按回车发送',
            simpleChatBoxPlaceholder: '在此输入您想了解的内容，按alt+回车换行，按回车发送',
            categoryList: ['通用模型', '业务模型'],
            forceRefresh: true // 强制刷新对话框
        };
    },
    props: {
        // 是否展示简洁的输入对话框
        simpleChatBox: {
            type: Boolean,
            default: false
        },
        /**
         * 是否正在输入
         */
        typing: {
            type: Boolean,
            default: false
        },
        /**
         * 是否需要语音输入按钮
         */
        showMic: {
            type: Boolean,
            default: true
        },
        /**
         * 输入框的内容
         */
        input: {
            type: String,
            default: ''
        },
        /**
         * 模型名称
         */
        model: {
            type: String,
            default: 'commonMode'
        },
        /**
         * 模型列表
         */
        modelList: {
            type: Array,
            default: () => []
        },
        /**
         * SessionID
         */
        sessionId: {
            type: String,
            default: ''
        }
    },
    computed: {
        curAssistant () {
            return this.$store.state.appSettings.curAssistant;
        },
        isDark () {
            return this.$store.state.appSettings.isDark;
        }
    },
    watch: {
        input (val) {
            this.prompt = val;
        },
        model: {
            immediate: true,
            handler: function (val) {
                this.modelList.forEach(item => {
                    if (item.value === val) {
                        this.setActive(item);
                    }
                });
            }
        },
        active (val) {
            this.$emit('update:model', val);
        }
    },
    created () {
        this.init();
    },
    mounted () {
        this.$bus.$on('setModelData', (item) => {
            this.setActive(item);
        });
        // 初始化是否隐藏模型菜单
        this.windowSizeHandle({
            target: {
                navigator: true,
                innerWidth: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
            }
        });
        this.listenWindowSize();
        document.addEventListener('click', this.bodyCloseMenus);
    },
    methods: {
        init () {
            let firstMode = this.modelList[0] || {};
            this.active = firstMode.value;
            this.activeName = firstMode.title;
            this.prompt = firstMode.prompt;
        },
        setmodelList (type) {
            const result = [];
            this.modelList.forEach(item => {
                if (type === item.category) {
                    result.push(item);
                }
            });
            return result;
        },
        setActive (item) {
            // 智能客服、智能运维是特殊的socket连接，直接连接各自后端的websocket，需要断开调用平台的Socket，再去连客服运维的Socket
            const specialSeviceArr = ['intel-customer', 'opera-assistant'];
            if (specialSeviceArr.indexOf(this.active) > -1 && this.active !== item.value) {
                if (specialSeviceArr.indexOf(item.value) > -1) {
                    // 之前是智能客服、智能运维的Socket，新的也是智能客服、智能运维的Socket，断开后重新连接
                    this.$emit('reconnectSocket', { isSpecialSocket: true });
                } else {
                    // 之前是智能客服、智能运维的Socket，新的是直接连接调用平台的Socket，断开后重新连接
                    this.$emit('reconnectSocket', { isSpecialSocket: false });
                }
            } else if (specialSeviceArr.indexOf(this.active) === -1 && this.active !== item.value) {
                // 之前不是智能客服、智能运维的Socket
                if (specialSeviceArr.indexOf(item.value) > -1) {
                    // 新的是智能客服、智能运维的Socket
                    this.$emit('reconnectSocket', { isSpecialSocket: true });
                }
            }
            this.active = item.value;
            this.activeName = item.title;
            this.prompt = item.prompt;
            this.handelForceRefresh();
            this.$emit('update:model', item.value);
        },
        setModel (data) {
            this.modelList.forEach(item => {
                if (item.title === data) {
                    this.setActive(item);
                }
            });
        },
        showModel () {
            this.$bus.$emit('openAiModel', this.selectModeDialogCategory);
        },
        showSelectModeDialog (val) {
            this.selectModeDialogCategory = val;
            this.selectModeDialogShow = true;
        },
        listenWindowSize () {
            window.addEventListener('resize', this.windowSizeHandle, true);
        },
        // 根据宽度隐藏模型菜单栏
        windowSizeHandle (e) {
            // 必须是window对象的改变才能触发，因为video对象也会触发resize
            if (!e.target.navigator) {
                return;
            }
            this.selectModeDialogShow = false;
            this.innerWidth = e.target.innerWidth;
        },
        handelForceRefresh () {
            this.forceRefresh = true;
            this.$nextTick(() => {
                this.forceRefresh = false;
            });
        },
        handelFocusTyping (val) {
            this.focusTyping = val;
        },
        bodyCloseMenus (e) {
            let self = this;
            if (self.selectModeDialogShow === true) {
                self.selectModeDialogShow = false;
                self.focusTyping = false;
            }
        },
        handelModelSelect (val) {
            this.selectModeDialogShow = val;
            this.focusTyping = val;
        }
    },
    beforeDestroy () {
        window.removeEventListener('resize', this.windowSizeHandle);
        document.removeEventListener('click', this.bodyCloseMenus);
    }
};
</script>

<style scoped lang="scss">
.gpt-chatbox-content {
    -webkit-box-flex: 1;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    margin: 12px 0 8px;
    background: none;
    border-radius: 8px;
    position: relative;
    box-sizing: border-box;
    border: 1px solid transparent;
    &.focusTyping {
        border: 1px solid #126cff;
    }
}
.gpt-chatbox {
    // -webkit-box-flex: 1;
    // -ms-flex: 1 1 auto;
    // flex: 1 1 auto;
    // margin: 12px 0 12px;
    background: var(--msg-welcome-prompt-bg);
    box-shadow: 0px 2px 6px 0px rgba(7, 22, 51, 0.1);
    border-radius: 8px;
    position: relative;
    box-sizing: border-box;
    // &:hover {
    //    border: 1px solid #126cff;
    // }
    .gpt-chatbox__select--h5,
    .select-wrapper {
        // background-repeat: no-repeat;
        // background-size: cover;
        // background-image: var(--chatbox--bg);
        background: var(--chatbox-select-wrapper-bg);
        border-radius: 8px 8px 0px 0px;
        position: relative;
        font-size: 14px;
    }

    .gpt-chatbox__select--h5 {
        padding: 6px 8px;
        width: 100%;
        line-height: 20px;

        .h5-select__label {
            color: var(--placeholder-font-color);
        }

        .h5-select__value {
            color: var(--placeholder-font-color-active);
            font-weight: 500;
            font-family: PingFang SC-Medium, PingFang SC, SourceHanSansSC-Medium, SourceHanSansSC, Microsoft Yahei;
        }

        .h5-select__fold {
            float: right;
            color: var(--ai-model-classification-font);
            cursor: pointer;
        }
    }

    .select-wrapper {
        padding: 16px;
        margin-bottom: 4px;

        .select-row {
            display: flex;
            flex-direction: column;
            &:first-child{
                margin-bottom: 16px;
            }
            .title {
                white-space: nowrap;
                margin-right: 8px;
                font-size: 16px;
                font-weight: bolder;
                margin-left: 4px;
                color: var(--font-color);
                line-height: 20px;
                font-family: PingFang SC-Medium, PingFang SC, SourceHanSansSC-Medium, SourceHanSansSC, Microsoft Yahei;
                font-weight: 500;
            }

            .select-content {
                .item {
                    background: var(--chatbox-model-item-bg-color);
                    border-radius: 4px;
                    border: 1px solid rgba(18, 108, 255, 0.15);
                    height: 28px;
                    font-size: 14px;
                    color: var( --placeholder-font-color-active);
                    line-height: 26px;
                    display: inline-block;
                    margin: 0 3px;
                    margin-top: 8px;
                    padding: 0 8px;
                    cursor: pointer;
                    box-sizing: border-box;

                    &.active {
                        background: #126cff;
                        color: white;
                    }

                    &:hover {
                        background: #126cff;
                        color: white;
                    }
                }
            }
        }

        .showModelDetail {
            width: 16px;
            height: 16px;
            position: absolute;
            cursor: pointer;
            right: 4px;
            top: 4px;
            background-image: var(--chatbox-showModel-icon);

            &:hover {
                background-image: var(--chatbox-showModel-icon-hover);
            }
        }
    }

    .select-wrapper--dialog {
        position: absolute;
        bottom: calc(100% + 4px);
        z-index: 2;
        // padding: 20px 0 0 10px;
        background: var(--model-select-bg);
        width: 100%;
        max-height: 200px;
        overflow-y: auto;
        border-radius: 4px;
        box-shadow: 0 2px 6px 0 rgba(7, 22, 51, 0.2);
    }

    ::v-deep {
        .textarea-right {
            opacity: var(--chatbox-textarea-right);
            display: flex;
        }

        textarea {
            height: 100%;
        }
    }
}
</style>

<style lang="scss">
.show-detail-tooltip{
    font-size: 14px;
    color: #FFFFFF;
    line-height: 20px;
    background: rgba(7, 22, 51, 0.85) !important;
    transform: translateY(8px);
    padding: 2px 4px;
    border-radius: 2px;
    border: none !important;
    .popper__arrow{
        display: none;
    }
}
.show-detail-tooltip-dark{
    background: rgba(17, 19, 27, 0.85) !important;
}
</style>
